import { components } from "../types/openapi";

export type NominalAccount = components["schemas"]["NominalAccountDto"];
export type PlatformDetails = components["schemas"]["PlatformDetailsDto"];
export type FeeStatistics = components["schemas"]["FeeStatisticsDto"];
export type RubWithdrawalRequestsContent = components["schemas"]["RubWithdrawalRequestGridDto"];
export type RubOperationContent = Omit<components["schemas"]["RubOperationGridDto"], "type"> & {
  type: RUB_OPERATION_TYPE_ENUM;
};
export type NominalAccountBankAccountsForBeneficiary = components["schemas"]["BeneficiaryBankAccountDetailsDto"];

export enum RUB_OPERATION_TYPE_ENUM {
  IN = "IN",
  OUT = "OUT",
  TRANSFER_IN = "TRANSFER_IN",
  TRANSFER_OUT = "TRANSFER_OUT",
  FEE = "FEE",
  LOCK = "LOCK",
  UNLOCK = "UNLOCK",
  LOCK_WITHDRAWAL = "LOCK_WITHDRAWAL",
  UNLOCK_WITHDRAWAL = "UNLOCK_WITHDRAWAL",
}

export const RUB_OPERATION_TYPE_TEXTS: Record<RUB_OPERATION_TYPE_ENUM, string> = {
  IN: "Пополнение",
  OUT: "Вывод",
  TRANSFER_IN: "Внутреннее пополнение",
  TRANSFER_OUT: "Списание",
  FEE: "Комиссия",
  LOCK: "Блокировка",
  UNLOCK: "Разблокировано",
  LOCK_WITHDRAWAL: "Блокировка на вывод",
  UNLOCK_WITHDRAWAL: "Разблокировано на вывод",
};

export const RUB_OPERATION_TYPE_TEXT_OPERATOR: Record<RUB_OPERATION_TYPE_ENUM, string> = {
  ...RUB_OPERATION_TYPE_TEXTS,
  TRANSFER_IN: "Переучет",
};
